import { render, staticRenderFns } from "./ErrorMailIcon.vue?vue&type=template&id=237de255&"
import script from "./ErrorMailIcon.vue?vue&type=script&lang=js&"
export * from "./ErrorMailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports